import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthProvider";
import { login } from "../services/authService";
import InputField from "../components/InputField";

const LoginPage = () => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const [usernameError, setUsernameError] = useState("");
	const [passwordError, setPasswordError] = useState("");

	const auth = useAuth();

	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();

		setUsernameError("");
		setPasswordError("");
		setError("");

		let formIsValid = true;

		if (!username) {
			setUsernameError("Il campo Username è obbligatorio.");
			formIsValid = false;
		}

		if (!password) {
			setPasswordError("Il campo Password è obbligatorio.");
			formIsValid = false;
		}

		if (!formIsValid) {
			return;
		}

		try {
			const [success, token, user, message] = await login(username, password);
			if (!success) {
				setError(message || "Errore di autenticazione.");
				return;
			}
			auth.login(token, user);
			navigate("/");
		} catch (error) {
			setError("Errore di autenticazione. Controlla le credenziali.");
		}
	};

	return (
		<section className="hero is-primary is-fullheight">
			<div className="hero-body">
				<div className="container">
					<div className="columns is-centered">
						<div className="column is-8-tablet is-6-desktop is-4-widescreen">
							{/* Aggiungi il nome dell'app e il logo sopra il box */}
							<div className="has-text-centered mb-6">
								<h1 className="title is-1 has-text-white">ANA ATRI</h1>
								<h1 className="subtitle is-2 has-text-white">Gestione Fatture</h1>
							</div>

							<form onSubmit={handleSubmit} className="box">
								<div className="field">
									<h2 className="title is-4 has-text-centered mb-4">Login</h2>
									<div className="control">
										<InputField
											label="Username"
											type="text"
											placeholder="Username"
											value={username}
											onChange={(e) => {
												setUsername(e.target.value);
												setUsernameError(""); // Reset errore su cambiamento
											}}
											errorMsg={usernameError}
										/>
									</div>
									<div className="control">
										<InputField
											label="Password"
											type="password"
											placeholder="Password"
											value={password}
											onChange={(e) => {
												setPassword(e.target.value);
												setPasswordError(""); // Reset errore su cambiamento
											}}
											errorMsg={passwordError}
										/>
									</div>
									{error && <p className="has-text-danger has-text-weight-semibold has-text-centered mb-4">{error}</p>}
									<div className="control">
										<button type="submit" className="button is-primary is-fullwidth">
											Login
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default LoginPage;
